import axiosInstanceNew from "../lib/axiosinstanceNew";

const EhcShowtReport = class {

    constructor(){
        this.baseUrl="ehc_swot";
    }

 
  async Add (data=[]) {
    return (await axiosInstanceNew.post(`${this.baseUrl}`,data));
  }
}

export default new EhcShowtReport();